import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainBarSection } from './components/PainBarSection';
import { RevelationSection } from './components/RevelationSection';
import { PhasesSection } from './components/PhasesSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { ValueStackSection } from './components/ValueStackSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <main className="w-full min-h-screen bg-[#FDF6F0] text-[#2D2028] overflow-x-hidden" data-id="element-0">
      <UrgencySection data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainBarSection data-id="element-3" />
      <RevelationSection data-id="element-4" />
      <PhasesSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <ValueStackSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
      <RecentPurchaseToast data-id="element-12" />

      {/* Footer Simple */}
      <footer className="py-8 text-center text-[#6B5B65] text-sm border-t border-[#E8D8E0] bg-[#F3E8F0]" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} Código Hormonal. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-15">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </main>;
}